import React from 'react';
import './ExerciseSteps.css';

const InfoStep = ({ step, onContinue, isFirstStep }) => {
  return (
    <div className="step-container">
      <div className="step-content">
        <h2 className="step-title">{step.title}</h2>
        <div className="step-text">
          {step.content}
        </div>
      </div>
      <div className="step-actions">
        <button 
          className="step-button primary"
          onClick={onContinue}
        >
          {isFirstStep ? 'Empezar' : 'Continuar'}
        </button>
      </div>
    </div>
  );
};

export default InfoStep; 